import { NightLightsSystem } from '@inter-ikea-storageone/range';
import { lightScene } from 'ducks/layout';
import { BehaviorParameters } from 'rangeConfig/@types';

const disableNightModeBehavior = ({ coreApi, dispatch }: BehaviorParameters) => {
  dispatch(lightScene());
  coreApi.getSystem<NightLightsSystem>('NightLightsSystem')?.disable();
};

export default disableNightModeBehavior;
